module.exports = __webpack_public_path__ + "static/media/beheer.46f7cd95.svg";